<template>
  <div class="countries-accordion" @click.stop="">
    <div v-for="(country,index) in allCountries" :key="index">
      <div class="filter-option">
        <div class="accordion-button country">
          <div class="acc-left" @click.prevent.stop="onCountryClicked(country,index)">
            <label :for="`countrySelected_${instanceName}`" class="checkbox-label country-label">
              <input :id="`countrySelected_${instanceName}`" v-model="country.selected" type="checkbox" tabindex="0">
              <span v-if="someRegionsSelected(country)" class="checkbox-checkmark incomplete" />
              <span v-else class="checkbox-checkmark" />
              {{ country.name }} <small><strong>{{ regionCount(country) }}</strong></small>
            </label>
          </div>
          <div class="acc-right" @click="toggleCountry(country,index)">
            <img v-if="!country.open" class="lazyload" src="../../../assets/img/src/icons/chevron-down.svg" alt="Down chevron" height="12px" width="12px">
            <img v-if="country.open" class="lazyload" src="../../../assets/img/src/icons/chevron-up.svg" alt="Up chevron" height="12px" width="12px">
          </div>
        </div>
      </div>
      <!-- REGIONS -->
      <div v-show="country.open">
        <div class="destinations">
          <div class="destinations-mobile">
            <div class="destinations-accordion">
              <div v-for="destination in getCountryDestinations(country.id)" :key="destination.id">
                <div>
                  <div class="accordion-button">
                    <div class="acc-left">
                      <div v-if="showDestinationGroupingName(destination)" class="destination-grouping">
                        {{ destination.groupingName }}
                      </div>
                    </div>
                    <div class="acc-right" />

                    <div class="acc-left">
                      <label :for="`destinationSelected_${instanceName}`" class="checkbox-label deslabel" @click.prevent.stop="onDestinationClicked(destination, country)">
                        <input :id="`destinationSelected_${instanceName}`" v-model="destination.selected" type="checkbox" tabindex="0">
                        <span v-if="someSubRegionsSelected(destination)" class="checkbox-checkmark incomplete" />
                        <span v-else class="checkbox-checkmark" />
                        {{ destination.name }}
                        <small><strong>{{ subDestinationsCount(destination) }}</strong></small>
                      </label>
                    </div>
                    <div v-if="destination.id == 1 || destination.id == 4" class="acc-right" @click.prevent.stop="openSubRegions(destination)">
                      <img v-if="!destination.open" class="lazyload" src="../../../assets/img/src/icons/chevron-down.svg" alt="Down chevron" height="12px" width="12px">
                      <img v-if="destination.open" class="lazyload" src="../../../assets/img/src/icons/chevron-up.svg" alt="Up chevron" height="12px" width="12px">
                    </div>
                  </div>
                  <!-- SUBREGIONS -->
                  <div v-show="destination.open && (destination.id == 1 || destination.id == 4)" class="accordion-content">
                    <div v-for="subregion in destination.subRegions" :key="subregion.id">
                      <div class="sub-destination-btn" @click.prevent.stop="selectSubDestination(subregion, destination)">
                        <label :for="`subregionSelected_${instanceName}`" class="checkbox-label sublabel">
                          <input :id="`subregionSelected_${instanceName}`" v-model="subregion.selected" type="checkbox">
                          <span class="checkbox-checkmark" /> {{ subregion.description }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _ } from 'vue-underscore';
import Bus from '../../../events/bus';
import cfg from '../../../config/config';
import responsive from '../../../mixins/responsive';

export default {
  name: 'Destinations',
  mixins: [responsive],
  props: {
    instanceName: { type: String, default: '' },
  },
  data() {
    return {
      subDestinations: [],
      regionsSelected: [],
      subregionsSelected: [],
      currentRegion: null,
    };
  },
  computed: {
    allDestinations: {
      get() {
        return this.$store.getters['results/getAllDestinations'];
      },
      set(value) {
        this.$store.commit('results/setAllDestinations', value);
      },
    },
    allCountries: {
      get() {
        return this.$store.getters['results/getAllDestinationCountries'];
      },
      set(value) {
        this.$store.commit('results/setAllDestinationCountries', value);
      },
    },
    REGION_IDS() {
      return this.$store.getters['results/getRegionIDs'];
    },
    subRegions() {
      if (this.currentRegion) {
        this.subDestinations = this.currentRegion.subRegions;
      }
      return this.subDestinations;
    },
    getDestinations() {
      return this.$store.getters['results/getDestinations'];
    },
    getSubDestinations() {
      return this.$store.getters['results/getSubDestinations'];
    },
    filteredVillasAmountAvailable() {
      return this.$store.getters['results/getAvailablePropertiesAll'].length;
    },
    currentCollectionList() {
      return this.$store.getters['pages/getCollectionData'];
    },
  },
  watch: {
    getDestinations(n, o) {
      this.checkIfAllSelected();
    },
    allCountries() {
      this.allCountries.forEach((country) => {
        const countryRegions = this.regionsSelected.filter((reg) => reg.countryId == country.id);
        countryRegions.length > 0 ? country.selected = true : country.selected = false;
      });
    },
  },
  created() {
    this.previousDestinationGroupName = null;
  },
  mounted() {
    this.$store.dispatch('results/setupDestinations');
    this.$store.dispatch('results/setupDestinationCountries');
    Bus.$on('restoreFilterFromStore', this.restoreFilterFromStore);
    Bus.$on('restoreFilterFromURL', this.restoreFilterFromURL);
    Bus.$on('restoreFilterFromCookies', this.restoreFilterFromCookies);
    Bus.$on('resetRegions', this.clearDestinations);
    Bus.$on('selectRegions', this.selectRegions);
    Bus.$on('selectSubRegions', this.selectSubRegions);
    Bus.$on('removeRegion', this.removeRegion);
    Bus.$on('removeSubRegion', this.removeSubRegion);
    Bus.$on('clearCountries', this.clearCountries);
    Bus.$emit('filterMounted', 'regions');
  },
  beforeDestroy() {
    // Removed on 25/09/23 - CU-862k9kvut
    // this.currentCollectionList ? this.clearDestinations() : null;
    Bus.$off('restoreFilterFromStore', this.restoreFilterFromStore);
    Bus.$off('restoreFilterFromURL', this.restoreFilterFromURL);
    Bus.$off('restoreFilterFromCookies', this.restoreFilterFromCookies);
    Bus.$off('resetRegions', this.clearDestinations);
    Bus.$off('selectRegions', this.selectRegions);
    Bus.$off('selectSubRegions', this.selectSubRegions);
    Bus.$off('removeRegion', this.removeRegion);
    Bus.$off('clearCountries', this.clearCountries);
    Bus.$off('removeSubRegion', this.removeSubRegion);
  },
  methods: {
    showDestinationGroupingName(destination) {
      let show = false;
      if (destination.groupingName == null || (destination.groupingName != null && destination.groupingName == this.previousDestinationGroupName)) {
        // no group name or has a group name and same as previous
        show = false;
      }
      else {
        show = true;
      }
      this.previousDestinationGroupName = destination.groupingName;
      return show;
    },
    getCountryDestinations(countryId) {
      return _.sortBy(this.allDestinations.filter((x) => x.countryId == countryId && x.id != 5 && this.getDestinationLiveVillaCount(x) > 0), (o) => o.groupingName);
    },
    getDestinationLiveVillaCount(dest) {
      let liveCount = 0;
      dest.subRegions.forEach((sr) => { liveCount += sr.liveVillaCount; });
      return liveCount;
    },
    toggleCountry(country, index) {
      country.open = !country.open;
    },
    restoreFilterFromURL() {
      this.allDestinations.forEach((x) => x.selected = false);
      if (this.$route.query.des) {
        const destinationsURL = [...new Set(this.$route.query.des.split(',').map((id) => Number(id)))];

        this.regionsSelected = this.allDestinations.filter((x) => destinationsURL.includes(x.id));
        this.regionsSelected.forEach((x) => x.selected = true);
        this.updateDestinationsSelected();

        if (this.$route.query.subdes) {
          const subdestinationsURL = [...new Set(this.$route.query.subdes.split(',').map((id) => Number(id)))];
          this.subregionsSelected = [...new Set(this.regionsSelected.map((x) => x.subRegions).flat().sort((a, b) => a.id - b.id).filter((s) => subdestinationsURL.includes(s.id)))];
          this.subregionsSelected.forEach((x) => x.selected = true);
          this.updateSubDestinationsSelected();
        } else {
          this.$store.commit('results/setSubDestinations', []);
          window.$cookies.set('subdestinations', '', cfg.neverExpire);
        }
        this.selectAllSubRegions();
      }
      else {
        this.allDestinations.forEach((x) => x.selected = false);
        this.resetValues();
      }
      this.checkIfAllSelected();
    },
    restoreFilterFromCookies() {
      const destinationsCookie = JSON.parse(window.$cookies.get('destinations'));
      const subdestinationsCookie = JSON.parse(window.$cookies.get('subdestinations'));
      this.allDestinations.forEach((x) => x.selected = false);
      if (!this.currentCollectionList && destinationsCookie && destinationsCookie.length > 0) {
        this.regionsSelected = this.allDestinations.filter((x) => destinationsCookie.includes(x.id));
        this.regionsSelected.forEach((x) => {
          x.selected = true;
        });
        this.$store.commit('results/setDestinations', this.regionsSelected);

        if (subdestinationsCookie && subdestinationsCookie.length > 0) {
          this.subregionsSelected = [...new Set(this.regionsSelected.map((x) => x.subRegions).flat().sort((a, b) => a.id - b.id).filter((s) => subdestinationsCookie.includes(s.id)))];
          this.subregionsSelected.forEach((x) => x.selected = true);
          this.$store.commit('results/setSubDestinations', this.subregionsSelected);
        }

        const destinationsIDs = this.regionsSelected.map((des) => des.id);
        const subDestinationsIDs = this.subregionsSelected.map((des) => des.id);
        this.$router.replace({ query: { ...this.$route.query, des: destinationsIDs.toString() || undefined, subdes: subDestinationsIDs.toString() || undefined } });
        this.selectAllSubRegions();
      }
      this.checkIfAllSelected();
    },

    restoreFilterFromStore() {
      this.regionsSelected = this.allDestinations.filter((x) => this.getDestinations.map((d) => d.id).includes(x.id));
      this.regionsSelected.forEach((x) => x.selected = true);
      this.$store.commit('results/setDestinations', this.regionsSelected);
      this.subregionsSelected = [...new Set(this.regionsSelected.map((x) => x.subRegions).flat().sort((a, b) => a.id - b.id).filter((s) => this.getSubDestinations.map((d) => d.id).includes(s.id)))];
      this.subregionsSelected.forEach((x) => x.selected = true);
      this.$store.commit('results/setSubDestinations', this.subregionsSelected);

      const destinationsIDs = this.regionsSelected.map((des) => des.id);
      const subDestinationsIDs = this.subregionsSelected.map((des) => des.id);
      this.$router.replace({ query: { ...this.$route.query, des: destinationsIDs.toString() || undefined, subdes: subDestinationsIDs.toString() || undefined } });
      this.checkIfAllSelected();
      this.selectAllSubRegions();
    },

    selectAllSubRegions() {
      // if no subregions selected, select them all
      this.regionsSelected.forEach((x) => {
        const subregionsSelected = x.subRegions.filter((sub) => sub.selected);
        if (subregionsSelected.length == 0) {
          x.subRegions.forEach((sub) => sub.selected = true);
        }
      });
    },

    // called from collection filters
    selectRegions(regions) {
      this.regionsSelected.forEach((x) => x.selected = false);
      this.regionsSelected = this.allDestinations.filter((x) => regions.map((r) => Number(r.id)).includes(x.id));
      this.regionsSelected.forEach((x) => x.selected = true);
      this.checkIfAllSelected();
    },

    selectSubRegions(subregions) {
      this.subregionsSelected = [...new Set(this.regionsSelected.map((x) => x.subRegions).flat().sort((a, b) => a.id - b.id).filter((s) => subregions.map((v) => v.id).includes(s.id)))];
      this.subregionsSelected.forEach((x) => x.selected = true);
    },

    checkIfAllSelected() {
      this.regionsSelected = this.allDestinations.filter((d) => !!d.selected);
      // this.allDestinations[0].selected = this.regionsSelected.length === this.allDestinations.length - 1;
    },

    updateDestinationsSelected() {
      const selectedIDs = this.regionsSelected.map((x) => x.id);
      if (!this.currentCollectionList) {
        window.$cookies.set('destinations', JSON.stringify(selectedIDs), cfg.neverExpire);
      }
      this.$store.commit('results/setDestinations', this.regionsSelected);
    },

    updateSubDestinationsSelected() {
      const selectedIDs = this.subregionsSelected.map((x) => x.id);
      if (!this.currentCollectionList) {
        window.$cookies.set('subdestinations', JSON.stringify(selectedIDs), cfg.neverExpire);
      }
      this.$store.commit('results/setSubDestinations', this.subregionsSelected);
    },

    // called from FilterTabs
    removeRegion(des) {
      des.open = false;
      des.selected = false;
      this.regionsSelected = this.regionsSelected.filter((x) => x.id !== des.id);
      const country = this.allCountries.filter((country) => country.id == des.countryId)[0];
      const countryRegions = this.regionsSelected.filter((reg) => reg.countryId == country.id);
      if (countryRegions.length == 0) country.selected = false;
      this.updateDestinationsSelected();
      this.clearSubRegionsForDestination(des);
      this.currentRegion = null;
      this.checkIfAllSelected();
      this.filterProperties();
    },
    removeSubRegion(sub) {
      if (sub.selected == true) {
        const destination = this.allDestinations.filter((des) => des.id == sub.regionId)[0];
        this.selectSubDestination(sub, destination);
      }
    },
    onCountryClicked(country) {
      const regions = this.allDestinations.filter((des) => des.countryId == country.id);
      country.selected = !country.selected;

      if (country.selected) {
        regions.forEach((reg) => {
          if (reg.selected == false) this.regionsSelected.push(reg);
          reg.selected = true;
          reg.subRegions.forEach((sub) => sub.selected = true);
        });
      } else {
        this.regionsSelected = this.regionsSelected.filter((reg) => reg.countryId != country.id);
        regions.forEach((reg) => {
          reg.selected = false;
          reg.subRegions.forEach((sub) => sub.selected = false);
        });
      }
      this.updateDestinationsSelected();
      this.checkIfAllSelected();
      this.filterProperties();
    },
    onDestinationClicked(des, country) {
      des.selected = !des.selected;
      if (des.selected) {
        this.currentRegion = des;
        this.regionsSelected.push(des);
        country.selected = true;
        des.subRegions.forEach((sub) => sub.selected = true);
        this.updateDestinationsSelected();
      }
      else {
        this.regionsSelected = this.regionsSelected.filter((x) => x.id !== des.id);
        const countryRegions = this.regionsSelected.filter((reg) => reg.countryId == country.id);
        if (countryRegions.length == 0) country.selected = false;
        this.currentRegion = null;
        this.clearSubRegionsForDestination(des);
        this.updateDestinationsSelected();
      }

      this.checkIfAllSelected();
      this.filterProperties();
    },

    selectSubDestination(sub, destination) {
      sub.selected = !sub.selected;
      // this.currentRegion = destination;
      const country = this.allCountries.filter((country) => country.id == destination.countryId)[0];

      // when selecting a sub region and the main region is not selected
      if (destination && !destination.selected) {
        destination.selected = true;
        this.regionsSelected.push(destination);
        country.selected = true;
        this.updateDestinationsSelected();
      }
      if (sub.selected) {
        this.subregionsSelected.push(sub);
        const unselectedSubRegions = destination.subRegions.filter((sub) => !sub.selected);
        if (unselectedSubRegions.length == 0) {
          destination.subRegions.forEach((sub) => {
            if (sub.selected) this.subregionsSelected.push(sub);
          });
          this.subregionsSelected = this.subregionsSelected.filter((sub) => sub.regionId != destination.id);
        }
      } else {
        // Removing a subregion
        this.subregionsSelected = this.subregionsSelected.filter((x) => x.id !== sub.id);
        const unselectedSubRegions = destination.subRegions.filter((sub) => !sub.selected);
        if (unselectedSubRegions.length > 0) {
          destination.subRegions.forEach((sub) => {
            if (sub.selected) this.subregionsSelected.push(sub);
          });
        }
        // If no subregions selected
        if (unselectedSubRegions.length == destination.subRegions.length) this.onDestinationClicked(destination, country);
      }

      this.subregionsSelected = [...new Set(this.subregionsSelected.sort((a, b) => a.id - b.id))];

      this.updateSubDestinationsSelected();
      this.filterProperties();
    },

    restoreSubRegionsForDestination() {
      const subRegionsToSelect = this.subRegions.filter((x) => this.subregionsSelected.map((s) => Number(s.id)).includes(x.id));
      subRegionsToSelect.forEach((x) => x.selected = true);
      this.subRegions[0].selected = subRegionsToSelect.length === this.subRegions.length;
    },

    clearCountries() {
      this.allCountries.forEach((country) => country.selected = false);
    },

    clearSubRegionsForDestination(des) {
      const subRegionIds = des.subRegions.map((x) => x.id);
      this.subregionsSelected = [...new Set(this.subregionsSelected.filter((x) => !subRegionIds.includes(x.id)))];
      des.subRegions.forEach((x) => x.selected = false);
      this.updateSubDestinationsSelected();
    },

    selectAllDestinations() {
      this.currentRegion = null;
      this.subregionsSelected = [];
      this.subregionsSelected = [...new Set(this.regionsSelected.map((x) => x.subRegions).flat().sort((a, b) => a.id - b.id))];
      this.updateDestinationsSelected();
      this.updateSubDestinationsSelected();
      this.allDestinations.forEach((x) => {
        x.selected = true;
        x.subRegions.forEach((s) => s.selected = true);
      });
      this.filterProperties();
    },

    someRegionsSelected(country) {
      const countryRegions = this.regionsSelected.filter((reg) => reg.countryId == country.id);
      return countryRegions.length < country.regions.length;
    },

    someSubRegionsSelected(des) {
      const subRegions = des.subRegions.filter((sub) => sub.selected);
      return des.subRegions.length > subRegions.length && subRegions.length != 0;
    },

    clearDestinations() {
      this.currentRegion = null;
      this.regionsSelected = [];
      this.subregionsSelected = [];
      this.$router.replace({
        query: {
          ...this.$route.query, region: undefined, subregion: undefined, des: undefined, subdes: undefined,
        },
      });

      this.resetValues();
      this.allDestinations.forEach((destination) => {
        destination.selected = false;
        destination.open = false;
        destination.subRegions.forEach((subregion) => {
          subregion.selected = false;
        });
      });
      this.allCountries.forEach((countries) => {
        countries.selected = false;
        countries.open = false;
      });

      this.filterProperties();
    },

    resetValues() {
      this.$store.commit('results/setDestinations', []);
      this.$store.commit('results/setSubDestinations', []);
      window.$cookies.set('destinations', '', cfg.neverExpire);
      window.$cookies.set('subdestinations', '', cfg.neverExpire);
    },

    filterProperties() {
      gsap.delayedCall(0.1, this.filterPropertiesLocally);
    },

    filterPropertiesLocally() {
      const destinationsIDs = this.regionsSelected.map((des) => des.id);
      const subDestinationsIDs = this.subregionsSelected.map((des) => des.id);
      this.$router.replace({ query: { ...this.$route.query, des: destinationsIDs.toString() || undefined, subdes: subDestinationsIDs.toString() || undefined } });
      this.currentCollectionList
        ? this.$store.dispatch('results/fetchProperties', { query: this.$route.query })
        : this.$store.dispatch('results/filterPropertiesLocally');
    },

    openSubRegions(des) {
      des.open = !des.open;
    },
    toggleOpenAll(des) {
      des.open = !des.open;
      this.allDestinations.forEach((x) => x.open = des.open);
    },
    closeAll() {
      this.allDestinations.forEach((x) => x.open = false);
    },

    regionCount(country) {
      const count = this.regionsSelected.filter((reg) => reg.countryId == country.id).length;
      if (count > 0 && count < country.regions.length) {
        country.selected = true;
        return `(${count})`;
      }
    },
    subDestinationsCount(destination) {
      const d = destination.subRegions.filter((x) => x.selected === true).length;
      return d !== 0 && d < destination.subRegions.length ? `(${d})` : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/settings/config.scss";

.destinations-accordion,.countries-accordion {
  margin: 0 -24px;

  .accordion-button {
    padding:21px 0 21px 0;
    min-height: 42px;
    width: 100%;
    outline: none;
    align-items: center;
    cursor: pointer;
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: 1fr;
    grid-gap: 0px;
    .acc-left {
      padding-left: 24px;
      &.country {
        padding-left: 8px;
        color: red;
      }
    }
    .acc-right {
      padding-right: 24px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: $grey;
      font-size: 14px;
      text-align: right;
      &:hover {
        color: $darkBlack;
      }
    }
    .destination-grouping {
      display: block;
      margin: 1em 0 1.5em 0;
      font-weight:500;
      text-transform:capitalize;
    }
    .deslabel {
      margin-left: 1.5em;
      text-transform:capitalize;
    }
    .checkbox-label {
      &.country-label {
        margin-bottom: 0;
      }
      & .checkbox-checkmark {
        top: 2px;
        &.incomplete {
          &:after {
            background-image: url('../../../assets/img/src/icons/minus.svg');
            background-color: $stoneCream;
            border: 1px solid $darkBlack;
          }
        }
      }
    }
  }

  .destinations-accordion {
    border-bottom: 1px solid $yellowStone;
    margin: 0;

    .accordion-button {
      padding: 0;
    }
    .acc-right {
      margin-bottom: 12px;
    }
  }

  .subs-count {
    font-weight: 500;
  }

  .accordion-content {
    text-transform: capitalize !important;
    margin: 5px 10px 12px 1em;
    @media (max-width: 330px) {
      margin: 20px 10px 12px 1em;
    }
  }

  .sub-destination-btn{
    display: flex;
    align-items: center;
    min-height: 42px;
    text-align: left;
  }

  .sublabel{
     margin: 0 0 0 4em;
  }
}
  .countries-accordion .country {
    border-bottom: 1px solid $yellowStone;
  }
</style>
